import { motion } from "framer-motion";
import './main-block.scss'

const wrapperVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1, y: 0,
        transition: {
            duration: 0.9,
            ease: "easeOut",
            when: "beforeChildren",
            staggerChildren: 0.18
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 32 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } }
};

export default function MainBlock() {
    return (
        <motion.div
            className="main-block container"
            id="about"
            initial="hidden"
            animate="visible"
            variants={wrapperVariants}
        >
            <motion.div className="main-block__wrapper" variants={itemVariants}>
                <motion.h1
                    className="main-block__title"
                    variants={itemVariants}
                >
                    Build wealth that outlives you
                </motion.h1>
                <motion.span
                    className="main-block__subtitle"
                    variants={itemVariants}
                >
                    We don’t chase trends — we create strategies built to last. From retirement to education, your goals become our roadmap. Long-term timelines. Real assets. Clear priorities.
                </motion.span>
                <motion.a
                    href={process.env.REACT_APP_LINK}
                    className="main-block__button button"
                    variants={itemVariants}
                    whileHover={{ scale: 1.06, boxShadow: "0px 0px 32px #ff00ac80" }}
                    whileTap={{ scale: 0.97 }}
                >
                    Open an Account
                </motion.a>
            </motion.div>
        </motion.div>
    );
}
